<em-main>
  <div class="header">
    <h2 i18n>Propositions</h2>
  </div>

  @if (tableEntries$ | async; as tableEntries) {
    <p-card class="p-card container">
      <p-table
        #underwritingProfilesTables
        [value]="tableEntries"
        [rows]="10"
        [rowsPerPageOptions]="[10, 25, 50]"
        [paginator]="true"
        [rowHover]="true"
        [globalFilterFields]="['policyNumber', 'clientFullName']"
        [filters]="{
          'status.value': {value: [status.APPROVED, status.REFUSED, status.CANCELED], matchMode: 'notIn'},
          agentInCharge: {
            value: [agent?.firstName + ' ' + agent?.lastName, noAgentInChargeStr],
            matchMode: 'in',
          },
        }"
        [sortField]="'submissionDate'"
        [sortOrder]="-1"
        paginatorDropdownScrollHeight="160px"
        styleClass="sales-table"
        responsiveLayout="scroll"
        dataKey="id">
        <ng-template pTemplate="caption">
          <div class="table-section__header">
            <span i18n class="table-section__header--title">Liste de propositions</span>
            <span class="p-input-icon-left">
              <i class="pi pi-search"></i>
              <input
                pInputText
                type="text"
                (input)="applyFilterGlobal($event)"
                i18n-placeholder
                placeholder="Chercher" />
            </span>
          </div>
        </ng-template>
        <ng-template pTemplate="header">
          <tr class="table-section__thead">
            <th i18n
              >Statut
              <p-columnFilter
                field="status.value"
                matchMode="in"
                display="menu"
                [showMatchModes]="false"
                [showOperator]="false"
                [showAddButton]="false"
                [showApplyButton]="false">
                <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                  <p-multiSelect
                    [style]="{width: '300px'}"
                    [ngModel]="value"
                    [options]="statusOptions | emTranslate"
                    i18n-placeholder
                    placeholder="Choisir"
                    (onChange)="filter($event.value)"
                    optionLabel="name"
                    optionValue="value">
                  </p-multiSelect>
                </ng-template>
              </p-columnFilter>
            </th>
            <th pSortableColumn="agentInCharge" i18n
              >Responsable
              <p-columnFilter
                field="agentInCharge"
                matchMode="in"
                display="menu"
                [showMatchModes]="false"
                [showOperator]="false"
                [showAddButton]="false"
                [showApplyButton]="false">
                <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                  <p-multiSelect
                    [style]="{width: '300px'}"
                    [ngModel]="value"
                    [options]="agentInChargeOptions"
                    i18n-placeholder
                    placeholder="Choisir"
                    (onChange)="filter($event.value)"
                    optionLabel="name"
                    optionValue="value">
                  </p-multiSelect>
                </ng-template>
              </p-columnFilter>
            </th>
            <th pSortableColumn="submissionDate" i18n
              >Date de soumission
              <p-sortIcon field="submissionDate"></p-sortIcon>
            </th>
            <th pSortableColumn="clientFullName" i18n
              >Nom complet
              <p-sortIcon field="clientFullName"></p-sortIcon>
            </th>
            <th pSortableColumn="policyNumber" i18n
              >Nº de police
              <p-sortIcon field="policyNumber"></p-sortIcon>
            </th>
            <th pSortableColumn="coverage" i18n
              >Couverture
              <p-sortIcon field="coverage"></p-sortIcon>
            </th>
            <th pSortableColumn="premium" i18n
              >Prime
              <p-sortIcon field="premium"></p-sortIcon>
            </th>
            <th></th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-tableEntry let-i="rowIndex">
          <tr>
            <td>
              <p-badge
                class="status-badge"
                [ngClass]="{
                  'status-badge--green': tableEntry.status.value === status.APPROVED,
                  'status-badge--red': tableEntry.status.value === status.REFUSED,
                  'status-badge--grey': tableEntry.status.value === status.CANCELED,
                  'status-badge--yellow': tableEntry.status.value === status.PENDING_UNDERWRITER_ACTION,
                  'status-badge--orange': tableEntry.status.value === status.PENDING_CLIENT_ACTION,
                }"></p-badge>
              {{ tableEntry.status.text }}
            </td>
            <td>{{ tableEntry.agentInCharge }}</td>
            <td>{{ tableEntry.submissionDate | emDate }}</td>
            <td>{{ tableEntry.clientFullName }}</td>
            <td>{{ tableEntry.policyNumber }}</td>
            <td>{{ tableEntry.coverage | emAmount: 'noDecimal' }}</td>
            <td>{{ tableEntry.premium | emAmount }}</td>
            <td class="text-right">
              <p-button
                class="progress-button"
                (onClick)="open(tableEntry.id)"
                i18n-label
                label="Ouvrir"
                icon="pi pi-folder-open"
                iconPos="left"></p-button>
            </td>
          </tr>
        </ng-template>
      </p-table>
    </p-card>
  } @else {
    <p-card class="p-card container">
      <p-table
        styleClass="sales-table"
        [paginator]="true"
        [value]="[' ', ' ', ' ', ' ']"
        [rows]="defaultRowsPerPage">
        <ng-template pTemplate="caption">
          <span i18n class="table-section__header--title">Liste des propositions</span>
        </ng-template>
        <ng-template pTemplate="header">
          <tr>
            <th i18n>Statut</th>
            <th i18n>Responsable</th>
            <th i18n>Date de soumission</th>
            <th i18n>Nom complet</th>
            <th i18n>Nº de police</th>
            <th i18n>Couverture</th>
            <th i18n>Prime</th>
            <th></th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body">
          <tr>
            @for (l of [].constructor(7); track l) {
              <td>
                <p-skeleton height="25px"></p-skeleton>
              </td>
            }
          </tr>
        </ng-template>
      </p-table>
    </p-card>
  }
</em-main>
